var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen"},[(
      _vm.$route.name !== 'invitationInscription' && _vm.$route.name !== 'invitation'
    )?_c('beta'):_vm._e(),_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var Component = ref.Component;
return [_c(Component,{tag:"component"})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }